function setWidth() {
    const value = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        value + 'px'
    )
}

let timeout

window.addEventListener('resize', function () {
    clearTimeout(timeout)
    timeout = setTimeout(setWidth, 500)
})

setWidth()
